import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import { useHomeContext } from '../../context'
import { Image } from '../../../../components/ui/image'

const FindTeviIdModal = ({ open, onClose }) => {
  const { t } = useHomeContext()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          maxWidth: 390,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 1,
          borderBottom: '1px solid #F4F4F4',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: 16,
            color: '#141414',
            letterSpacing: '-0.32px',
          }}
        >
          {t('findTeviId.title')}
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: '#141414' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ px: 2, pt: 1, pb: 2 }}>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 12,
            color: '#242424',
            textAlign: 'center',
            letterSpacing: '-0.24px',
            lineHeight: 1.4,
            mb: 1,
          }}
        >
          {t('findTeviId.description')}
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.25 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Image
              src="/assets/find-id-menu.png"
              alt="Open Menu bar"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Image
              src="/assets/find-id-copy.png"
              alt="Copy Tevi ID"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default FindTeviIdModal
